<script>
  import Constantes from "../../Classes/Constantes";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import DropDownDB from "../../componentes_basicos/DropDownDB.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
    import TelasAcessoNaoAutorizado from "../TelasAcessoNaoAutorizado.svelte";
    import { permissaoUsuario } from "../../Classes/Stores";

  const conexao = new Conexoes();
  let isLoading = false;
  let result = [];
  let id_campeonato;
  let prova = {
    nome_prova: "",
    descricao_prova: "",
    peso_prova: 0,
    id_categoria: "Digite a categoria",
    ordem_prova: 1,
  };

  let movimentos = [];

  function addMovimento() {
    movimentos = [
      ...movimentos,
      {
        nome_movimento: "",
        descricao_movimento: "",
        peso_movimento: 0,
        peso_tempo: 0,
        ordem: movimentos.length + 1,
      },
    ];
  }
  let config = {};
  async function RetornoDrop(e) {
    id_campeonato="";
    await id_campeonato;
    id_campeonato = e.detail.objeto.id;
    config = {
      api: Constantes.api_consultar_padrao,
      parametros: {
        query_code: "consulta_siglas_categorias_distinct",
        id_campeonato: id_campeonato,
      },
      nome_coluna_opcoes: "sigla",
      nome_coluna_saida: "id",
      filtravel: false,
      itens: "",
    };
  }
  let config_campeonato = {
    api: Constantes.api_consultar_padrao,
    parametros: {
      query_code: "consultar_todos_campeonatos",
    },
    nome_coluna_opcoes: "nome_campeonato",
    nome_coluna_saida: "id",
    filtravel: false,
    itens: "",
  };
  function removeMovimento(index) {
    console.log("Removendo movimento no índice:", index);
    movimentos = movimentos.filter((_, i) => i !== index);
    movimentos.forEach((mov, i) => (mov.ordem = i + 1)); // Atualiza ordens
  }

  async function salvarProva() {
    //const provaJson = JSON.stringify(prova);
   // const movimentosJson = JSON.stringify(movimentos);

    let parametros = {
      prova: prova,
      movimentos: movimentos,
    };
    isLoading = true;
    let result = await conexao.conecta(
      Constantes.api_inserir_prova,
      parametros,
      true
    );
    isLoading = false;
  }
</script>

<LoadingTela {isLoading} />
<br /><br />
{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_cadastrar_provas)}

<div class="container">
  <h2>Cadastro de Prova</h2>
  <label>Campeonato</label>

  <DropDownDb config={config_campeonato} on:retorno={RetornoDrop} />
  {#if id_campeonato > 0}
    <label>Nome da Prova</label>
    <input type="text" bind:value={prova.nome_prova} />

    <label>Descrição da Prova</label>
    <textarea bind:value={prova.descricao_prova} rows="3"></textarea>

    <label>Peso da Prova</label>
    <input type="number" bind:value={prova.peso_prova} />

    <label>Categoria</label>

    <DropDownDb {config} bind:saida={prova.id_categoria} />

    <label>Ordem da Prova</label>
    <input type="number" bind:value={prova.ordem_prova} />

    <h3>Movimentos da Prova</h3>
    <table class="movimento-table">
      <thead>
        <tr>
          <th>Nome do Movimento</th>
          <th>Descrição</th>
          <th>Peso</th>
          <th>Peso Tempo</th>
          <th>Ordem</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {#each movimentos as movimento, index}
          <tr class="movimento-row">
            <td>
              <input type="text" bind:value={movimento.nome_movimento} />
            </td>
            <td>
              <input type="text" bind:value={movimento.descricao_movimento} />
            </td>
            <td>
              <input type="number" bind:value={movimento.peso_movimento} />
            </td>
            <td>
              <input type="number" bind:value={movimento.peso_tempo} />
            </td>
            <td>
              <input type="number" readonly bind:value={movimento.ordem} />
            </td>
            <td>
              <button
                class="remove-btn"
                on:click={() => removeMovimento(index)}
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>

    <button class="add-btn" on:click={addMovimento}>Adicionar Movimento</button>
    <button class="save-btn" on:click={salvarProva}>Salvar Prova</button>
  {/if}
</div>
<br /><br />
{:else}
<TelasAcessoNaoAutorizado />

{/if}
<style>
  .container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  h2,
  h3 {
    text-align: center;
    color: #333;
  }

  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }

  .movimento-table {
    width: 100%;
    margin-bottom: 15px;
  }

  .movimento-table th,
  .movimento-table td {
    padding: 10px;
    text-align: left;
  }

  .movimento-row {
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    margin-bottom: 10px;
  }

  .remove-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #ff4d4d;
    font-size: 20px;
    transition: color 0.3s;
  }

  .remove-btn:hover {
    color: #e60000;
  }

  .add-btn,
  .save-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.3s;
    width: 100%;
    font-size: 16px;
    margin-top: 10px;
  }

  .add-btn:hover,
  .save-btn:hover {
    background: #0056b3;
  }
</style>
